import React from 'react'

import { Step } from './step'
import type { StepType } from './types'

const Steps: React.FC<{ steps: StepType[] }> = ({
  steps,
}: {
  steps: StepType[]
}) => {
  return (
    <div className="w-full rounded-md">
      {steps?.map((step: StepType, index: number) => (
        <Step
          key={`${step?.title}_${index}`}
          id={step?.id}
          stepNumber={index + 1}
          title={step?.title}
          description={step?.description}
          image={step?.image}
        />
      ))}
    </div>
  )
}

export { Steps }
